export enum ErrorMessages {
    TOKEN_EXPIRED_TOASTER =
      'This session has been expired. This could be due to a new login on the same account. You will now be redirected to the sign-in page, where you can securely sign in again to continue.',
    NOT_FOUND = 'Your store is not onboarded yet, Please proceed with onboarding process.'
  };